import { addCalendarDaysInAppTimezone, endOfDayInAppTimezone, getDatePartsInAppTimezone, startOfDayInAppTimezone, } from '@/shared/utils/app-timezone';
/** Default filter window: 7 days ago (Kabul start of day) through today (Kabul end of day). */
export function defaultFilterDateRange() {
    const today = getDatePartsInAppTimezone(new Date());
    const startDay = addCalendarDaysInAppTimezone(today.year, today.month, today.day, -7);
    return {
        startDate: startOfDayInAppTimezone(startDay),
        endDate: endOfDayInAppTimezone(today),
    };
}
/** Today only (Kabul start of day through end of day). */
export function todayFilterDateRange() {
    const today = getDatePartsInAppTimezone(new Date());
    return {
        startDate: startOfDayInAppTimezone(today),
        endDate: endOfDayInAppTimezone(today),
    };
}
